import React from 'react';
import {FiUser, FiHeart, FiSettings, FiLock,  FiUsers,FiInbox,FiBell } from 'react-icons/fi'

export const opts = [
    {symbol:<FiUser />,title:'Profiles', url:'/account'},
    {symbol:<FiHeart />,title:'Favorites', url:'/account/favorites'},
    {symbol:<FiSettings />,title:'Settings', url:'/account/setting'},
    {symbol:<FiLock />,title:'Change password', url:'/account/change'},
  
    // {symbol:<FiBriefcase />,title:'My Projects', url:'#/account/myprojects', sharp:true},
    // {symbol:<FiUsers />,title:'My Profiles', url:'#/account/profiles', sharp:true},
    // {symbol:<FiBarChart />,title:'Statistics', url:'#',  sharp:true},
    // {symbol:<FiSend />,title:'Chat', url:'#',  sharp:true},
    // {symbol:<FiCreditCard />,title:'Payment', url:'#', sharp:true},
    // {symbol:<FiMapPin />,title:'Location', url:'#',  sharp:true},
    // {symbol:<FiUsers />,title:'Team', url:'#',  sharp:true},
   
    // {symbol:<FiSlash />,title:'Blocked', url:'#/account/blocks', sharp:true},
   
    // {symbol:<FiArchive />,title:'Inbound', url:'/account/requests'},
    // {symbol:<FiInbox />,title:'Outbound', url:'#'},
  
    // {symbol:<FiMoon />,title:'Darkmode', url:'#',  sharp:true},
    // {symbol:<FiHelpCircle />,title:'Help & Support', url:'#',  sharp:true},
];

export const opts2 = [
    {symbol:<FiUsers />,title:'Invates', url:'/account/friendship'},
    {symbol:<FiInbox />,title:'Requests', url:'/account/requests'},
    {symbol:<FiBell />,title:'Notifications', url:'/account/notification'},
]